import { CascadingFilterNode } from '@app/components/data-table/cascading-filter';
import { InsightsTaxonomyCategory } from '@shared/api/types';

/**
 * The slug the API writes on every taxonomy tier for goods that have no base
 * product. It is one bucket rather than a branch: beneath it sit the goods
 * themselves, so selecting it at any tier ends the drill.
 */
export const UNCATEGORISED_SLUG = 'uncategorised';

/**
 * The taxonomy tree as cascading-filter nodes. The API nests the uncategorised
 * bucket through all three tiers so that it filters like any other path, but
 * as a choice it is one thing, so here it is a leaf: picking it applies
 * straight away rather than opening two columns of the same word.
 */
export const toTaxonomyFilterNodes = (
  categories: readonly InsightsTaxonomyCategory[] | undefined
): CascadingFilterNode[] =>
  (categories ?? []).map((category) => ({
    value: category.slug,
    label: category.name,
    children:
      category.slug === UNCATEGORISED_SLUG
        ? undefined
        : category.subCategories.map((subCategory) => ({
            value: subCategory.slug,
            label: subCategory.name,
            children: subCategory.bases.map((base) => ({
              value: base.slug,
              label: base.name,
            })),
          })),
  }));
